// Shared, dependency-free price arithmetic for the screen and server checks.
export const annualExtra = (old: number, next: number, cycle: number): number => cycle > 0 ? (next - old) * 365 / cycle : 0
export function raisedPrice(old: number, choice: string): number {
  if (choice === '5%' || choice === '10%') return Math.ceil(old * (choice === '5%' ? 105 : 110) / 5000) * 50
  return old + (choice === '3' ? 300 : 200)
}
